import { atexto, minix, pregunta } from "@/components/functions/alertas"
import router from '@/router'
import axios from 'axios'
import { io } from "socket.io-client"

export const actions = {
    async obtener_data({ commit, state, dispatch, getters }, data) {
        try {
            const config = {
                method: 'get',
                url: `${getters.URL_SERVIDOR}/api/${data.api}`,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${state.token_sesion}`
                }
            }
            commit('set_loading', true)
            let r = await axios(config)

            if (r.data.notificacion == 'error') {
                atexto({ titulo: 'Error', cuerpo: r.data.mensaje, icono: 'error' })
                commit('set_loading', false)
            } else if (r.data.data.length == 0) {
                if (data.notificacion) {

                    minix({ icon: 'info', mensaje: data.notificacion.mensaje, tiempo: 3000 })
                    commit('set_loading', false)
                    return []

                } else {

                    if (process.env.NODE_ENV != 'production') console.log('Se maneja desde el componente - no hay registros')
                    commit('set_loading', false)
                    return []
                }
            } else {
                // commit('set_recv_data', r.data.data)
                commit('set_loading', false)
                return r.data.data
            }


        } catch (error) {
            if (error.message == "Network Error") {
                alert('No se pudo conectar con el servidor')
            } else {
                console.log('Error: ' + error)
            }

        }
    },
    async guardar_data({ commit, getters, state }, data) {
        try {
            const config = {
                method: 'post',
                url: `${getters.URL_SERVIDOR}/api/${data.api}`,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${state.token_sesion}`
                },
                data: { data: data.formulario }
            }

            // se incrusta el id de la empresa en el formulario
            config.data.data.empresa = state.id_empresa_seleccionada

            const r = await axios(config)

            if (r.status == 200 || r.status == 201) {
                if (r.data.notificacion == 'exito') {
                    // minix({ icon: 'success', mensaje: r.data.mensaje, tiempo: 3000 })

                    atexto({
                        titulo: 'Listo!',
                        cuerpo: r.data.mensaje,
                        icono: 'success'
                    })

                    commit('set_limpiar', true)
                    return { datos: r.data.data, limpiar: true }

                } else if (r.data.notificacion == 'exito_minix') {
                    minix({ icon: r.data.icono, mensaje: r.data.mensaje, tiempo: 3000 })

                    return { datos: r.data.data }

                } else if (r.data.notificacion == 'atexto_error') {
                    atexto({
                        titulo: 'Error!',
                        cuerpo: r.data.mensaje,
                        icono: 'error'
                    })

                    commit('set_limpiar', false) // este retur es para que el formulario no se limpie al darle guardar

                } else if (r.data.notificacion == 'ok') {

                    commit('set_loading', false)
                    if (process.env.NODE_ENV == 'development') console.log('Las notificaciones se manejan desde el componente')
                    commit('set_limpiar', true)

                } else if (r.data.notificacion == 'atexto_info') {

                    commit('set_loading', false)
                    atexto({ titulo: 'Atención!', cuerpo: r.data.mensaje, icono: 'warning' })
                    commit('set_limpiar', false)

                } else if (r.data.notificacion == 'retorno_sin_alerta') {

                    return r.data.data

                } else if (r.data.notificacion == 'retorno') {
                    if (r.data.data.length == 0) {
                        minix({ icon: 'info', mensaje: 'No se encontraron registros', tiempo: 3000 })
                        return []
                    } else {
                        console.log('Retorno sin notificaciones')
                        return r.data.data
                    }
                } else {
                    // atexto({ titulo: 'Listo!', cuerpo: 'Guardado con éxito', icono: 'success' })
                    minix({ icon: 'success', mensaje: 'Guardado con éxito', tiempo: 3000 })
                    return r.data.data
                }

            } else {
                minix({ icon: 'info', mensaje: 'HUBO UN ERROR AL GUARDAR', tiempo: 3000 })
            }

        } catch (error) {
            if (error.response.data.error.message == 'This attribute must be unique') {
                minix({ icon: 'error', mensaje: 'Este código ya existe', tiempo: 3000 })
                return { limpiar: false }
            } else {
                console.log(error)
                atexto({ titulo: 'Error!', cuerpo: error.message, icono: 'error' })
            }
        }
    },
    async actualizar_data({ commit, state, dispatch, getters }, data) {
        try {
            const config = {
                method: 'put',
                url: `${getters.URL_SERVIDOR}/api/${data.api}`,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${state.token_sesion}`
                },
                data: { data: data.formulario }
            }

            const r = await axios(config)

            if (r.status == 201 || r.status == 200 || r.status == 204) {
                // if (r.data.data.attributes) {
                //     atexto({ titulo: 'Listo!', cuerpo: 'Registro actualizado con éxito', icono: 'success' })
                // } 

                if (r.data.notificacion == 'exito') {
                    atexto({ titulo: 'Listo!', cuerpo: r.data.mensaje, icono: 'success' })
                    return r.data.data
                } else if (r.data.notificacion == 'exito_minix') {
                    minix({ icon: 'success', mensaje: r.data.mensaje, tiempo: 3000 })
                    return r.data.data
                }
                else if (r.data.notificacion == 'error') {
                    atexto({
                        titulo: 'Error!',
                        cuerpo: r.data.mensaje,
                        icono: 'error'
                    })
                } else if (r.data.notificacion == 'ok') {
                    console.log('Las notificaciones se manejan desde el componente - actulizacion')
                } else if (r.data.data) {
                    minix({ icon: 'success', mensaje: 'Actualizado con exito', tiempo: 3000 })
                } else {
                    atexto({
                        titulo: 'Error!',
                        cuerpo: 'Parámetro desconocido',
                        icono: 'error'
                    })
                }
            } else {
                minix({ icon: 'info', mensaje: 'HUBO UN ERROR AL ACTUALIZAR', tiempo: 6000 })
                console.log(r.data)
            }

        } catch (error) {
            console.log(error)
        }
    },
    async borrar_data({ commit, state, dispatch, getters }, data) {
        try {

            const config = {
                method: 'delete',
                url: `${getters.URL_SERVIDOR}/api/${data.api}`,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${state.token_sesion}`
                }
            }
            const r = await axios(config)

            if (r.status == 200 || r.status == 204) {
                minix({ icon: 'success', mensaje: 'BORRADO :)', tiempo: 3000 })
            } else {
                minix({ icon: 'info', mensaje: 'HUBO UN ERROR AL BORRAR', tiempo: 6000 })
            }

        } catch (error) {
            console.log(error)
        }
    },

    cerrar_sesion({ commit, state }) {
        pregunta({ titulo: 'Seguro que deseas salir?', texto: 'Está a punto de salir del sistema', afirmacion: 'Si, salir!' }, async (i) => {


            if (i) {
                commit('set_loading', true)
                commit('set__socket', false)
                commit('set_id_empresa_seleccionada', 0)
                localStorage.removeItem('fdb')

                setTimeout(() => {
                    router.replace('Login')
                }, 1000);


                // let b = await axios.post(`${IP}:${PUERTO}/api/login/cerrarsesion`, f, this.$store.state.token)
                // console.log(b.data)
            } else {
                commit('set_loading', false)
            }
        })

    },
    async obtener_datos_usuario({ commit, state, getters, dispatch }) {
        try {
            const config = {
                method: 'get',
                url: `${getters.URL_SERVIDOR}/api/users/me?populate=*`,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${state.token_sesion}`
                }
            }
            let r = await axios(config)

            // insetar las empresas que tiene el usuario
            let f = {
                api: `usuario-empresas/c/buscar/${r.data.id}`
            }

            let empresas = await dispatch("obtener_data", f)
            r.data.empresas = empresas

            if (state.id_empresa_seleccionada != 0) {

                // Esta consulta es para saber la sucursal que está amarrada a la empresa seleccionada
                // LO QUE HACE ENTONCES, ES SI CAMBIO DE EMPRESA, BUSCA LA SUCURSAL QUE TENGO ASGINADA EN DICHA EMPRESA
                // por ejemplo si en zamba tengo asignada la sucursal 7, entonces al cambiar de empresa, la sucursal 7 se establece y si cambio a clickphoto se establece la sucursal 1, etc

                let g = {
                    api: `sucursales-asignadas?filters[id_usuario][$eq][0]=${r.data.id}&filters[empresa][$eq][1]=${state.id_empresa_seleccionada}`
                }

                let solicitud = await dispatch("obtener_data", g)

                // inserto la sucursal en el objeto del usuario
                if (solicitud.length != 0) r.data.sucursal_asignada = solicitud[0].sucursal_asignada

                let nombre_sucursal = state.sucursales.find(item => item.codigo === r.data.sucursal_asignada);
                r.data.nombre_sucursal_asignada = nombre_sucursal.nombre

            } else {
                console.log('No se ha seleccionado empresa aún')
            }

            if (r.status == 200) {
                commit('set_datos_usuario', r.data)
            }

        } catch (error) {

            console.log(error)
        }
    },
    async crear_usuario({ commit, state, getters }, data) {
        try {
            const config = {
                method: 'post',
                url: `${getters.URL_SERVIDOR}/api/${data.api}`,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${state.token_sesion}`
                },
                data: data.formulario
            }

            const r = await axios(config)

            if (r.status == 200 || r.status == 201) {
                if (r.data.message) {
                    minix({ icon: 'info', mensaje: r.data.message, tiempo: 6000 })
                    return r
                } else {
                    minix({ icon: 'success', mensaje: 'GUARDADO CON EXITO', tiempo: 3000 })
                    return r
                }

            } else {
                minix({ icon: 'info', mensaje: 'HUBO UN ERROR AL GUARDAR', tiempo: 6000 })
            }

        } catch (error) {
            minix({ icon: 'error', mensaje: error.message, tiempo: 6000 })
            console.warn(error)
        }
    },
    async obtener_roles({ state, commit, getters }) {
        try {
            const config = {
                method: 'get',
                url: `${getters.URL_SERVIDOR}/api/users-permissions/roles`,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${state.token_sesion}`
                }
            }

            const r = await axios(config)

            if (r.status == 200) {
                commit('set_roles', r.data.roles)
            } else {
                minix({ icon: 'info', mensaje: 'HUBO UN ERROR AL OBTENER ROLES', tiempo: 6000 })
            }

        } catch (error) {
            minix({ icon: 'error', mensaje: error.message, tiempo: 6000 })
            console.warn(error)
        }
    },
    async obtener_usuarios({ state, commit, getters }) {
        try {
            const config = {
                method: 'get',
                url: `${getters.URL_SERVIDOR}/api/users?filters[sucursal_asignada][$eq]=${state.sucursal_seleccionada.codigo}&filters[empresa][$eq]=${state.id_empresa_seleccionada}&populate=*`,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${state.token_sesion}`
                }
            }

            const r = await axios(config)
            if (r.status == 200 || r.status == 201) {
                commit('set_usuarios', r.data)
            } else {
                minix({ icon: 'info', mensaje: 'HUBO UN ERROR AL OBTENER ROLES', tiempo: 6000 })
            }

        } catch (error) {
            minix({ icon: 'error', mensaje: error.message, tiempo: 6000 })
            console.warn(error)
        }
    },
    async actualizar_usuario({ state, commit, getters }, data) {
        try {
            const config = {
                method: 'put',
                url: `${getters.URL_SERVIDOR}/api/users/${data.id}`,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${state.token_sesion}`
                },
                data: data.formulario
            }

            const r = await axios(config)
            if (r.status == 200 || r.status == 201) {
                minix({ icon: 'success', mensaje: 'ACTUALIZADO CON EXITO', tiempo: 3000 })
            } else {
                minix({ icon: 'info', mensaje: 'HUBO UN ERROR AL OBTENER ROLES', tiempo: 6000 })
            }

        } catch (error) {
            minix({ icon: 'error', mensaje: error.message, tiempo: 6000 })
            console.warn(error)
        }
    },
    async iniciar_conexion({ commit, state, dispatch, getters }) {

        if (process.env.NODE_ENV != 'production') console.log('Inciando conexión socket')

        let url_ = state.preferencias.PROTOCOLO + '://' + state.preferencias.SOCKET

        const socket = io(url_, {
            path: process.env.NODE_ENV == 'production' ? '/app/clickphoto/socket.io' : '',
            // path: '/app/coope/socket.io',
            auth: {
                token: state.token_sesion
            },
            transports: ['websocket']
        })

        socket.on('connect', () => {
            socket.on("message::bienvenida", (info) => {
                if (process.env.NODE_ENV != 'production') console.log(info.mensaje)
                commit('set__socket', true)
            })
        })

        socket.on('action:function:tienda', (info) => {
            dispatch(info.data.fn)
        })
    },
    async obtener_correlativos({ commit, state, dispatch, getter }) {
        // CORRELATIVO EN TRASALDOS
        let f = {
            api: `correlativos/c/obtener_correlativos?empresa=${state.id_empresa_seleccionada}`
        }

        let recv_traslados = await dispatch("obtener_data", f)

        commit('set_correlativos', recv_traslados)
    },
    async actualizar_modulos({ commit, state, dispatch, getters }, modulo) {
        const confg = {
            method: 'get',
            url: `${getters.URL_SERVIDOR}/api/${modulo.data.api}`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${state.token_sesion}`
            }
        }

        const d = await axios(confg)
        if (d.data.data.length != 0) {
            if (d.data.data[0].tipo_de_lista == 'comestibles') {
                commit('set_numero_pedido_comestibles', d.data.data[0].numero_pedido)
            } else {
                commit('set_numero_pedido_bebidas', d.data.data[0].numero_pedido)
            }
            commit(modulo.data.set, d.data.data)
        } else {
            console.log('no hay datos')
        }
    },
    validar_seleccion_empresa({ commit, state }) {
        if (state.id_empresa_seleccionada == null || state.id_empresa_seleccionada == '' || state.id_empresa_seleccionada == undefined) {
            router.replace('empresas')
        } else {
            return true
        }
    },
    async obtener_lista_usuarios_panel({ commit, state, dispatch, getters }, data) {
        let f = {
            api: `usuario-empresas/c/usuario-empresa?empresa=${state.id_empresa_seleccionada}`
        }

        let resultados = await dispatch("obtener_data", f)
        commit('set_lista_usuarios_panel', resultados)
    },
    async obtener_permisos({ commit, state, dispatch, getters }) {
        let f = {
            // api: `permisos/c/obtener?empresa=${state.id_empresa_seleccionada}&id_usuario=${state.datos_usuario.id}&sucursal=${state.datos_usuario.sucursal_asignada}`
            api: `permisos/c/obtener?empresa=${state.id_empresa_seleccionada}&id_usuario=${state.datos_usuario.id}`
        }
        let resultados = await dispatch("obtener_data", f)
        commit('set_permisos', resultados)
    },
    async obtener_empresas_por_usuario({ commit, state, dispatch, getters }) {
        let f = {
            api: `usuario-empresas/c/buscar/${state.usuario_seleccionado_permisos.id}`
        }
        let resultados = await dispatch("obtener_data", f)
        commit('set_empresas_por_usuario', resultados)
    },
    async descargar_datos({ commit, state, getters }) {
        if (state.rutas.length != 0) {
            try {

                for (let i = 0; i < state.rutas.length; i++) {
                    const e = state.rutas[i];

                    const config = {
                        method: 'get',
                        url: `${getters.URL_SERVIDOR}/api/${e.api}`,
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${state.token_sesion}`
                        }
                    }

                    const d = await axios(config)

                    if (d.status == 200) {
                        commit(e.set, d.data.data)
                    }
                }
            } catch (error) {
                console.error(error)
            }
        }
    }
}
